import s from './Loader.module.css'
import loadingSvg from './Loading.svg'

export const Loader = () => <div className={s.loader}>
    <img src={loadingSvg} alt="Loading..." width="108" height="108"/>
</div>


